import { Outlet } from '@remix-run/react'
import type { ComponentProps } from 'react'
import { SdGuideHeader } from '~/components/header/sd/SdGuideHeader'
import { Backdrop } from '~/components/modal/Backdrop'
import { SDReserve } from '~/features/reserve/Reserve'
import { SDGuide } from './index'

export function SDGuideRoot(props: ComponentProps<typeof SDGuide>) {
  const { restaurant } = props
  return (
    <div itemScope itemType="https://schema.org/Restaurant">
      <Backdrop>
        <SdGuideHeader restaurant={restaurant} />
        <SDGuide {...props} />
      </Backdrop>
      <SDReserve />
      <Outlet />
    </div>
  )
}
